// extracted by mini-css-extract-plugin
export default {"courseRub":"Rate_courseRub__zqeBk","discountClass":"Rate_discountClass__poxCK","header":"Rate_header__zcYjG","icon":"Rate_icon__6WbsB","main":"Rate_main__L4EvE"};